import React from 'react';
import './../css/about.css';
import side_about from '../assets/side-about.png';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-content">
        <h2>Who We Are</h2>
        <p>DefenseK is more than a cybersecurity company; we are a partner in your digital resilience. Our mission is simple – to outsmart cyber adversaries with innovative solutions that go beyond traditional defenses. We specialize in crafting customized security blueprints, ensuring privacy, agility, and trust in everything we do.</p>
        <p>Our approach focuses on staying ahead of emerging threats, designing adaptive security systems and integrating next-gen privacy practices. We provide high-performance, cutting-edge services that are resilient against even the most sophisticated attacks, ensuring comprehensive protection to keep your systems secure and prepared for evolving cyber challenges.</p>
      </div>
      <div className="about-image">
        <img src={side_about} alt="Our Team" />
      </div>
    </section>
  );
};

export default About;
